module.exports = __webpack_public_path__ + "static/media/SideImage.5f5151f6.png";